import { Drawer } from '../../components/Drawer';
import { LanguageIcon } from '../../icons/NavIcons';
import {
  Container,
  Item,
  ItemButton,
  ItemLabel,
  LanguageSelectorButton,
  LanguageSelectorLabel,
  List,
  Thumbnail,
  ThumbnailImage,
  ThumbnailPlaceholder,
  Title,
} from './MenuDrawer.styles';
import type { MenuDrawerProps } from './MenuDrawer.types';

export function MenuDrawer({
  open,
  onClose,
  title,
  closeLabel,
  items,
  noImageLabel,
  desktopOffset,
  width,
  languageSelector,
}: MenuDrawerProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      aria-label={title}
      closeLabel={closeLabel}
      placement="left"
      desktopOffset={desktopOffset}
      width={width}
      closeButtonPlacement="navSheet"
    >
      <Container>
        <Title>{title}</Title>
        <List>
          {items.map((item) => (
            <Item key={item.id}>
              <ItemButton
                type="button"
                onClick={item.onSelect}
                $active={item.active}
                aria-current={item.active ? 'page' : undefined}
              >
                <Thumbnail>
                  {item.imageUrl ? (
                    <ThumbnailImage src={item.imageUrl} alt="" />
                  ) : (
                    <ThumbnailPlaceholder aria-hidden="true">{noImageLabel}</ThumbnailPlaceholder>
                  )}
                </Thumbnail>
                <ItemLabel>{item.label}</ItemLabel>
              </ItemButton>
            </Item>
          ))}
        </List>
        {languageSelector && (
          <LanguageSelectorButton
            type="button"
            onClick={languageSelector.onSelect}
            $active={languageSelector.active}
          >
            <LanguageIcon size={18} />
            <LanguageSelectorLabel>{languageSelector.label}</LanguageSelectorLabel>
          </LanguageSelectorButton>
        )}
      </Container>
    </Drawer>
  );
}
